/* tslint:disable */
/* eslint-disable */
/**
 * Seamworks API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { StyleOperationCreateDto } from '../model/';
// @ts-ignore
import type { StyleOperationDto } from '../model/';
// @ts-ignore
import type { StyleOperationDtoPagedResultDto } from '../model/';
// @ts-ignore
import type { StyleOperationUpdateDto } from '../model/';
/**
 * StyleOperationApi - axios parameter creator
 * @export
 */
export const StyleOperationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {Array<number>} [selectedIds] 
         * @param {number} [styleId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCloneMultipleOperationsPost: async (selectedIds?: Array<number>, styleId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/cloneMultipleOperations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (selectedIds) {
                localVarQueryParameter['selectedIds'] = selectedIds;
            }

            if (styleId !== undefined) {
                localVarQueryParameter['styleId'] = styleId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [styleOprId] 
         * @param {number} [styleId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCloneOperationPost: async (styleOprId?: number, styleId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/cloneOperation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (styleOprId !== undefined) {
                localVarQueryParameter['styleOprId'] = styleOprId;
            }

            if (styleId !== undefined) {
                localVarQueryParameter['styleId'] = styleId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} [selectedIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeleteMultipleOperationsDelete: async (selectedIds?: Array<number>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/DeleteMultipleOperations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (selectedIds) {
                localVarQueryParameter['selectedIds'] = selectedIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [tktTexValue] 
         * @param {StyleOperationDto} [styleOperationDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEditOperationPost: async (tktTexValue?: string, styleOperationDto?: StyleOperationDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/editOperation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (tktTexValue !== undefined) {
                localVarQueryParameter['tktTexValue'] = tktTexValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(styleOperationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [styleId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGetGroupNumberGet: async (styleId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/getGroupNumber`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (styleId !== undefined) {
                localVarQueryParameter['styleId'] = styleId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [styleOprId] 
         * @param {number} [styleId] 
         * @param {number} [seamLengthUnit] 
         * @param {string} [tktTexValue] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGetOperationGet: async (styleOprId?: number, styleId?: number, seamLengthUnit?: number, tktTexValue?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/getOperation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (styleOprId !== undefined) {
                localVarQueryParameter['styleOprId'] = styleOprId;
            }

            if (styleId !== undefined) {
                localVarQueryParameter['styleId'] = styleId;
            }

            if (seamLengthUnit !== undefined) {
                localVarQueryParameter['seamLengthUnit'] = seamLengthUnit;
            }

            if (tktTexValue !== undefined) {
                localVarQueryParameter['tktTexValue'] = tktTexValue;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [styleId] 
         * @param {number} [seamLengthUnit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGetOperationsGet: async (styleId?: number, seamLengthUnit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/getOperations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (styleId !== undefined) {
                localVarQueryParameter['styleId'] = styleId;
            }

            if (seamLengthUnit !== undefined) {
                localVarQueryParameter['seamLengthUnit'] = seamLengthUnit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [styleId] 
         * @param {string} [stitchCode] 
         * @param {number} [seamLengthUnit] 
         * @param {string} [tktTexValue] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGetRecentlyUsedStyleOperationStitchDataGet: async (styleId?: number, stitchCode?: string, seamLengthUnit?: number, tktTexValue?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/GetRecentlyUsedStyleOperationStitchData`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (styleId !== undefined) {
                localVarQueryParameter['styleId'] = styleId;
            }

            if (stitchCode !== undefined) {
                localVarQueryParameter['stitchCode'] = stitchCode;
            }

            if (seamLengthUnit !== undefined) {
                localVarQueryParameter['seamLengthUnit'] = seamLengthUnit;
            }

            if (tktTexValue !== undefined) {
                localVarQueryParameter['tktTexValue'] = tktTexValue;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {StyleOperationDto} [styleOperationDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSaveOperationPost: async (styleOperationDto?: StyleOperationDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/saveOperation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(styleOperationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStyleOperationGet: async (sorting?: string, skipCount?: number, maxResultCount?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/styleOperation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (sorting !== undefined) {
                localVarQueryParameter['Sorting'] = sorting;
            }

            if (skipCount !== undefined) {
                localVarQueryParameter['SkipCount'] = skipCount;
            }

            if (maxResultCount !== undefined) {
                localVarQueryParameter['MaxResultCount'] = maxResultCount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStyleOperationIdDelete: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiStyleOperationIdDelete', 'id', id)
            const localVarPath = `/api/styleOperation/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStyleOperationIdGet: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiStyleOperationIdGet', 'id', id)
            const localVarPath = `/api/styleOperation/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {StyleOperationUpdateDto} [styleOperationUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStyleOperationIdPut: async (id: number, styleOperationUpdateDto?: StyleOperationUpdateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiStyleOperationIdPut', 'id', id)
            const localVarPath = `/api/styleOperation/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(styleOperationUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {StyleOperationCreateDto} [styleOperationCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStyleOperationPost: async (styleOperationCreateDto?: StyleOperationCreateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/styleOperation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(styleOperationCreateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [operationId] 
         * @param {string} [tktTexVal] 
         * @param {StyleOperationDto} [styleOperationDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiValidateAlreadyExistingOperationWithSameGroupPost: async (operationId?: number, tktTexVal?: string, styleOperationDto?: StyleOperationDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/validateAlreadyExistingOperationWithSameGroup`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (operationId !== undefined) {
                localVarQueryParameter['operationId'] = operationId;
            }

            if (tktTexVal !== undefined) {
                localVarQueryParameter['tktTexVal'] = tktTexVal;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(styleOperationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [styleId] 
         * @param {number} [groupNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiValidateGroupNumberGet: async (styleId?: number, groupNumber?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/validateGroupNumber`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (styleId !== undefined) {
                localVarQueryParameter['styleId'] = styleId;
            }

            if (groupNumber !== undefined) {
                localVarQueryParameter['GroupNumber'] = groupNumber;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StyleOperationApi - functional programming interface
 * @export
 */
export const StyleOperationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StyleOperationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {Array<number>} [selectedIds] 
         * @param {number} [styleId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCloneMultipleOperationsPost(selectedIds?: Array<number>, styleId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCloneMultipleOperationsPost(selectedIds, styleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StyleOperationApi.apiCloneMultipleOperationsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [styleOprId] 
         * @param {number} [styleId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCloneOperationPost(styleOprId?: number, styleId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCloneOperationPost(styleOprId, styleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StyleOperationApi.apiCloneOperationPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<number>} [selectedIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDeleteMultipleOperationsDelete(selectedIds?: Array<number>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDeleteMultipleOperationsDelete(selectedIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StyleOperationApi.apiDeleteMultipleOperationsDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [tktTexValue] 
         * @param {StyleOperationDto} [styleOperationDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEditOperationPost(tktTexValue?: string, styleOperationDto?: StyleOperationDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEditOperationPost(tktTexValue, styleOperationDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StyleOperationApi.apiEditOperationPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [styleId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiGetGroupNumberGet(styleId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiGetGroupNumberGet(styleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StyleOperationApi.apiGetGroupNumberGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [styleOprId] 
         * @param {number} [styleId] 
         * @param {number} [seamLengthUnit] 
         * @param {string} [tktTexValue] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiGetOperationGet(styleOprId?: number, styleId?: number, seamLengthUnit?: number, tktTexValue?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StyleOperationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiGetOperationGet(styleOprId, styleId, seamLengthUnit, tktTexValue, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StyleOperationApi.apiGetOperationGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [styleId] 
         * @param {number} [seamLengthUnit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiGetOperationsGet(styleId?: number, seamLengthUnit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StyleOperationDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiGetOperationsGet(styleId, seamLengthUnit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StyleOperationApi.apiGetOperationsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [styleId] 
         * @param {string} [stitchCode] 
         * @param {number} [seamLengthUnit] 
         * @param {string} [tktTexValue] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiGetRecentlyUsedStyleOperationStitchDataGet(styleId?: number, stitchCode?: string, seamLengthUnit?: number, tktTexValue?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StyleOperationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiGetRecentlyUsedStyleOperationStitchDataGet(styleId, stitchCode, seamLengthUnit, tktTexValue, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StyleOperationApi.apiGetRecentlyUsedStyleOperationStitchDataGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {StyleOperationDto} [styleOperationDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSaveOperationPost(styleOperationDto?: StyleOperationDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSaveOperationPost(styleOperationDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StyleOperationApi.apiSaveOperationPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStyleOperationGet(sorting?: string, skipCount?: number, maxResultCount?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StyleOperationDtoPagedResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStyleOperationGet(sorting, skipCount, maxResultCount, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StyleOperationApi.apiStyleOperationGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStyleOperationIdDelete(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStyleOperationIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StyleOperationApi.apiStyleOperationIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStyleOperationIdGet(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StyleOperationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStyleOperationIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StyleOperationApi.apiStyleOperationIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {StyleOperationUpdateDto} [styleOperationUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStyleOperationIdPut(id: number, styleOperationUpdateDto?: StyleOperationUpdateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StyleOperationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStyleOperationIdPut(id, styleOperationUpdateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StyleOperationApi.apiStyleOperationIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {StyleOperationCreateDto} [styleOperationCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStyleOperationPost(styleOperationCreateDto?: StyleOperationCreateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StyleOperationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStyleOperationPost(styleOperationCreateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StyleOperationApi.apiStyleOperationPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [operationId] 
         * @param {string} [tktTexVal] 
         * @param {StyleOperationDto} [styleOperationDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiValidateAlreadyExistingOperationWithSameGroupPost(operationId?: number, tktTexVal?: string, styleOperationDto?: StyleOperationDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiValidateAlreadyExistingOperationWithSameGroupPost(operationId, tktTexVal, styleOperationDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StyleOperationApi.apiValidateAlreadyExistingOperationWithSameGroupPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [styleId] 
         * @param {number} [groupNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiValidateGroupNumberGet(styleId?: number, groupNumber?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiValidateGroupNumberGet(styleId, groupNumber, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StyleOperationApi.apiValidateGroupNumberGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * StyleOperationApi - factory interface
 * @export
 */
export const StyleOperationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StyleOperationApiFp(configuration)
    return {
        /**
         * 
         * @param {Array<number>} [selectedIds] 
         * @param {number} [styleId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCloneMultipleOperationsPost(selectedIds?: Array<number>, styleId?: number, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.apiCloneMultipleOperationsPost(selectedIds, styleId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [styleOprId] 
         * @param {number} [styleId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCloneOperationPost(styleOprId?: number, styleId?: number, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.apiCloneOperationPost(styleOprId, styleId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<number>} [selectedIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeleteMultipleOperationsDelete(selectedIds?: Array<number>, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.apiDeleteMultipleOperationsDelete(selectedIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [tktTexValue] 
         * @param {StyleOperationDto} [styleOperationDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEditOperationPost(tktTexValue?: string, styleOperationDto?: StyleOperationDto, options?: RawAxiosRequestConfig): AxiosPromise<number> {
            return localVarFp.apiEditOperationPost(tktTexValue, styleOperationDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [styleId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGetGroupNumberGet(styleId?: number, options?: RawAxiosRequestConfig): AxiosPromise<number> {
            return localVarFp.apiGetGroupNumberGet(styleId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [styleOprId] 
         * @param {number} [styleId] 
         * @param {number} [seamLengthUnit] 
         * @param {string} [tktTexValue] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGetOperationGet(styleOprId?: number, styleId?: number, seamLengthUnit?: number, tktTexValue?: string, options?: RawAxiosRequestConfig): AxiosPromise<StyleOperationDto> {
            return localVarFp.apiGetOperationGet(styleOprId, styleId, seamLengthUnit, tktTexValue, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [styleId] 
         * @param {number} [seamLengthUnit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGetOperationsGet(styleId?: number, seamLengthUnit?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<StyleOperationDto>> {
            return localVarFp.apiGetOperationsGet(styleId, seamLengthUnit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [styleId] 
         * @param {string} [stitchCode] 
         * @param {number} [seamLengthUnit] 
         * @param {string} [tktTexValue] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGetRecentlyUsedStyleOperationStitchDataGet(styleId?: number, stitchCode?: string, seamLengthUnit?: number, tktTexValue?: string, options?: RawAxiosRequestConfig): AxiosPromise<StyleOperationDto> {
            return localVarFp.apiGetRecentlyUsedStyleOperationStitchDataGet(styleId, stitchCode, seamLengthUnit, tktTexValue, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {StyleOperationDto} [styleOperationDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSaveOperationPost(styleOperationDto?: StyleOperationDto, options?: RawAxiosRequestConfig): AxiosPromise<number> {
            return localVarFp.apiSaveOperationPost(styleOperationDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [sorting] 
         * @param {number} [skipCount] 
         * @param {number} [maxResultCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStyleOperationGet(sorting?: string, skipCount?: number, maxResultCount?: number, options?: RawAxiosRequestConfig): AxiosPromise<StyleOperationDtoPagedResultDto> {
            return localVarFp.apiStyleOperationGet(sorting, skipCount, maxResultCount, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStyleOperationIdDelete(id: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiStyleOperationIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStyleOperationIdGet(id: number, options?: RawAxiosRequestConfig): AxiosPromise<StyleOperationDto> {
            return localVarFp.apiStyleOperationIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {StyleOperationUpdateDto} [styleOperationUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStyleOperationIdPut(id: number, styleOperationUpdateDto?: StyleOperationUpdateDto, options?: RawAxiosRequestConfig): AxiosPromise<StyleOperationDto> {
            return localVarFp.apiStyleOperationIdPut(id, styleOperationUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {StyleOperationCreateDto} [styleOperationCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStyleOperationPost(styleOperationCreateDto?: StyleOperationCreateDto, options?: RawAxiosRequestConfig): AxiosPromise<StyleOperationDto> {
            return localVarFp.apiStyleOperationPost(styleOperationCreateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [operationId] 
         * @param {string} [tktTexVal] 
         * @param {StyleOperationDto} [styleOperationDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiValidateAlreadyExistingOperationWithSameGroupPost(operationId?: number, tktTexVal?: string, styleOperationDto?: StyleOperationDto, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.apiValidateAlreadyExistingOperationWithSameGroupPost(operationId, tktTexVal, styleOperationDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [styleId] 
         * @param {number} [groupNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiValidateGroupNumberGet(styleId?: number, groupNumber?: number, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.apiValidateGroupNumberGet(styleId, groupNumber, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StyleOperationApi - object-oriented interface
 * @export
 * @class StyleOperationApi
 * @extends {BaseAPI}
 */
export class StyleOperationApi extends BaseAPI {
    /**
     * 
     * @param {Array<number>} [selectedIds] 
     * @param {number} [styleId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StyleOperationApi
     */
    public apiCloneMultipleOperationsPost(selectedIds?: Array<number>, styleId?: number, options?: RawAxiosRequestConfig) {
        return StyleOperationApiFp(this.configuration).apiCloneMultipleOperationsPost(selectedIds, styleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [styleOprId] 
     * @param {number} [styleId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StyleOperationApi
     */
    public apiCloneOperationPost(styleOprId?: number, styleId?: number, options?: RawAxiosRequestConfig) {
        return StyleOperationApiFp(this.configuration).apiCloneOperationPost(styleOprId, styleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<number>} [selectedIds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StyleOperationApi
     */
    public apiDeleteMultipleOperationsDelete(selectedIds?: Array<number>, options?: RawAxiosRequestConfig) {
        return StyleOperationApiFp(this.configuration).apiDeleteMultipleOperationsDelete(selectedIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [tktTexValue] 
     * @param {StyleOperationDto} [styleOperationDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StyleOperationApi
     */
    public apiEditOperationPost(tktTexValue?: string, styleOperationDto?: StyleOperationDto, options?: RawAxiosRequestConfig) {
        return StyleOperationApiFp(this.configuration).apiEditOperationPost(tktTexValue, styleOperationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [styleId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StyleOperationApi
     */
    public apiGetGroupNumberGet(styleId?: number, options?: RawAxiosRequestConfig) {
        return StyleOperationApiFp(this.configuration).apiGetGroupNumberGet(styleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [styleOprId] 
     * @param {number} [styleId] 
     * @param {number} [seamLengthUnit] 
     * @param {string} [tktTexValue] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StyleOperationApi
     */
    public apiGetOperationGet(styleOprId?: number, styleId?: number, seamLengthUnit?: number, tktTexValue?: string, options?: RawAxiosRequestConfig) {
        return StyleOperationApiFp(this.configuration).apiGetOperationGet(styleOprId, styleId, seamLengthUnit, tktTexValue, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [styleId] 
     * @param {number} [seamLengthUnit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StyleOperationApi
     */
    public apiGetOperationsGet(styleId?: number, seamLengthUnit?: number, options?: RawAxiosRequestConfig) {
        return StyleOperationApiFp(this.configuration).apiGetOperationsGet(styleId, seamLengthUnit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [styleId] 
     * @param {string} [stitchCode] 
     * @param {number} [seamLengthUnit] 
     * @param {string} [tktTexValue] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StyleOperationApi
     */
    public apiGetRecentlyUsedStyleOperationStitchDataGet(styleId?: number, stitchCode?: string, seamLengthUnit?: number, tktTexValue?: string, options?: RawAxiosRequestConfig) {
        return StyleOperationApiFp(this.configuration).apiGetRecentlyUsedStyleOperationStitchDataGet(styleId, stitchCode, seamLengthUnit, tktTexValue, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {StyleOperationDto} [styleOperationDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StyleOperationApi
     */
    public apiSaveOperationPost(styleOperationDto?: StyleOperationDto, options?: RawAxiosRequestConfig) {
        return StyleOperationApiFp(this.configuration).apiSaveOperationPost(styleOperationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [sorting] 
     * @param {number} [skipCount] 
     * @param {number} [maxResultCount] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StyleOperationApi
     */
    public apiStyleOperationGet(sorting?: string, skipCount?: number, maxResultCount?: number, options?: RawAxiosRequestConfig) {
        return StyleOperationApiFp(this.configuration).apiStyleOperationGet(sorting, skipCount, maxResultCount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StyleOperationApi
     */
    public apiStyleOperationIdDelete(id: number, options?: RawAxiosRequestConfig) {
        return StyleOperationApiFp(this.configuration).apiStyleOperationIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StyleOperationApi
     */
    public apiStyleOperationIdGet(id: number, options?: RawAxiosRequestConfig) {
        return StyleOperationApiFp(this.configuration).apiStyleOperationIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {StyleOperationUpdateDto} [styleOperationUpdateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StyleOperationApi
     */
    public apiStyleOperationIdPut(id: number, styleOperationUpdateDto?: StyleOperationUpdateDto, options?: RawAxiosRequestConfig) {
        return StyleOperationApiFp(this.configuration).apiStyleOperationIdPut(id, styleOperationUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {StyleOperationCreateDto} [styleOperationCreateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StyleOperationApi
     */
    public apiStyleOperationPost(styleOperationCreateDto?: StyleOperationCreateDto, options?: RawAxiosRequestConfig) {
        return StyleOperationApiFp(this.configuration).apiStyleOperationPost(styleOperationCreateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [operationId] 
     * @param {string} [tktTexVal] 
     * @param {StyleOperationDto} [styleOperationDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StyleOperationApi
     */
    public apiValidateAlreadyExistingOperationWithSameGroupPost(operationId?: number, tktTexVal?: string, styleOperationDto?: StyleOperationDto, options?: RawAxiosRequestConfig) {
        return StyleOperationApiFp(this.configuration).apiValidateAlreadyExistingOperationWithSameGroupPost(operationId, tktTexVal, styleOperationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [styleId] 
     * @param {number} [groupNumber] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StyleOperationApi
     */
    public apiValidateGroupNumberGet(styleId?: number, groupNumber?: number, options?: RawAxiosRequestConfig) {
        return StyleOperationApiFp(this.configuration).apiValidateGroupNumberGet(styleId, groupNumber, options).then((request) => request(this.axios, this.basePath));
    }
}

